export const AccountHeaders = [
    { field: "createdAt", title: "DATE/TIME", width: 100 },
	{ field: "trnId", title: "TRANSACTION ID", width: 150 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 150 },
	{ field: "apprentice", title: "APPRENTICE", width: 150 },
	{ field: "amountToRaise", title: "AMOUNT RAISED", sortable: false, width: 100 },
	{ field: "interestRate", title: "INTEREST", sortable: false, width: 50 },
	{ field: "commitmentFee", title: "COMMITMENT FEE", sortable: false, width: 120 },
    { field: "expectedProfit", title: "EXPECTED PROFIT", sortable: false, width: 100 },
    { field: "programSavings", title: "PROGRAMMED SAVINGS", sortable: false, width: 100 },
	{ field: "", title: "ACTION", sortable: false, width: 60 },
]




export const AccountData = [
	{
		objectId:1,
		transactionId:"TNNN-1233",
		businessType: "Electrical parts",
        apprentice:"Timilehin",
        amount: "10000",
        interest: "12%",
        commitmentFee: "10",
        profit: "Existing",
        savings: "20000"
	},
]